export default __webpack_public_path__ + "static/media/slider1.99b8de1a.png";